const getters = {};

/**
 * 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
getters.isOpen = (state) => {
  let result = false;
  for (let key in state.open) {
    if (state.open[key]) {
      result = true;
      break;
    }
  }
  return result;
};

/**
 * Alert 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
getters.isAlertOpen = (state) => {
  return state.open.alert;
};

/**
 * Confirm 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
getters.isConfirmOpen = (state) => {
  return state.open.confirm;
};

/**
 * Data 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
getters.isDataModalOpen = (state) => {
  return state.open.data;
};

/**
 * 모달의 타이틀을 리턴한다.
 * @param {Object} state
 * @returns {string}
 */
getters.header = (state) => state.header;

/**
 * 모달의 메시지를 리턴한다.
 * @param {Object} state
 * @returns {string}
 */
getters.message = (state) => state.message;

// Data 모달의 컴포넌트를 리턴한다.
getters.component = (state) => state.component;

/**
 * 모달의 callback을 리턴한다.
 * @param {*} state
 * @returns {Function}
 */
getters.callback = (state) => state.callback;

/**
 * 모달의 closeCallback 리턴한다.
 * @param {*} state
 * @returns {Function}
 */
getters.closeCallback = (state) => state.closeCallback;

getters.btnName = (state) => state.btnName;

export default {
  ...getters,
};
